import { useSelector } from "react-redux";
import { base_url } from "../../services/configServices/config";

const PreLoader = () => {
  const isLoader = !useSelector((state) => state.isLoader);
  const setting = useSelector((state) => state.meta?.setting);

  return (
    <div className={`preloader ${isLoader ? "loaded" : ""}`}>
      <div
        className="centrize full-width"
        style={{ display: isLoader ? "none" : "table" }}
      >
        <div className="vertical-center">
          <div className="spinner-logo">
            <img
              src={base_url + setting?.logo}
              alt={setting?.title}
              className="rounded"
            />
            <div className="spinner-dot">
              <div className="spinner-line" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreLoader;
